<template>
  <header class="header">
    <div class="header__content">
      <h2 class="header__title">
        {{ title }}
      </h2>
      <span v-if="quantity"> {{ positionQuantity }}</span>
    </div>
    <div class="header__actions">
      <ui-button
        icon="icon-plus"
        outlined
        color="primary"
        @click="$emit('open-add-dialog')"
      >
        {{ $t("message.common.add") }}
      </ui-button>
    </div>
  </header>
</template>

<script>
import { pluralCount } from "@/helpers/helpers";

export default {
  name: "StoreLocatorFaqTitle",
  props: {
    title: {
      type: String,
      required: true
    },
    quantity: {
      type: Number,
      default: 0
    }
  },
  computed: {
    positionQuantity() {
      return pluralCount("message.pluralForms.position", this.quantity);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $spacing * 3;
  position: relative;
  padding-left: $spacing * 2.5;

  &__content {
    display: flex;
    align-items: center;
    gap: $spacing * 1.5;

    span {
      @include font-size(14px);
      color: $gray;
      border-left: 1px solid $gray;
      padding-left: $spacing * 1.5;
    }
  }

  &__title {
    font-family: "Montserrat", sans-serif;
    @include font-size(16px);
    font-weight: 500;
  }

  &:before {
    position: absolute;
    content: "";
    display: block;
    width: 3px;
    height: 100%;
    background-color: $lime;
    left: 0;
  }
}
</style>
